<template>
  <div>
    <a-form :form="form" layout="inline" class="productHeadForm">
      <a-form-item :label="labelTitle">
        <a-date-picker v-model="date" @change="changeDate" format="YYYY-MM-DD" />
      </a-form-item>
      <a-form-item :label="head.varietyTitle">
        <a @click="openVariety">请选择</a>
      </a-form-item>
    </a-form>
    <div v-if="!noAlert">
      <a-alert :message="msg" type="info" show-icon style="margin-bottom: 10px;"/>
    </div>
    <a-table
      :columns="columns"
      :data-source="allList" 
      :pagination="false" 
      rowKey="id"
      :scroll="{y: 300}"
    >
      <span slot="varietyTitle"><span style="color: red">*</span> 品种</span>
      <span slot="stockingSpecificationTitle"><span style="color: red">*</span> 规格(尾/斤)</span>
      <span slot="stockingNumTitle"><span style="color: red">*</span> 数量(尾)</span>
      <span slot="stockingWeightTitle"><span style="color: red">*</span> 重量(斤)</span>
      <span v-for="el in ['stockingSpecification','stockingNum','stockingWeight','proofingHarvestNum','proofingHarvestWeight','dieNum','dieWeight']" :key="el" :slot="el" slot-scope="t,record">
        <span v-if="record.isLast" style="font-size: 14px;font-weight: bold;">{{ t }}</span>
        <a-input-number v-else placeholder="请输入" v-model="record[el]" @change="() => changeVal(record)" :min="0" :precision="el.indexOf('Num') >= 0 ? 0 : len"/>
      </span>
      <template slot="varietyName" slot-scope="t,record">
        <span v-if="record.isLast" style="font-size: 14px;font-weight: bold;">{{ t }}</span>
        <span v-else >{{ t }}</span>
      </template>
    </a-table>
  </div>
</template>

<script>
import col from '../Columns'
import { mapMutations,mapState } from 'vuex';
import moment from 'moment'
export default {
  props: ['list','listField','tabKey','head','columnsField','resDate','noAlert','costField','varietyType'],
  data() {
    const columns = col[this.columnsField]
    return {
      form: this.$form.createForm(this),
      columns,
      len: 2,
      date: null,
    }
  },
  watch: {},
  computed: {
    ...mapState('empirical',['feedVarietyList','detail']),
    labelTitle(){
      return <span><span class='colorRed'>*</span>{this.head.dateTitle}</span>
    },
    last(){
      let stockingNum = 0,stockingWeight = 0
      this.list.forEach(el => {
        stockingNum += Number(el[`${this.costField}Num`] || 0)
        stockingWeight += Number(el[`${this.costField}Weight`] || 0)
      })
      return {
        isLast: true,
        varietyName: '总计',
        [`${this.costField}Num`]: Number(stockingNum).toFixed(0),
        [`${this.costField}Weight`]: Number(stockingWeight).toFixed(this.len),
      }
    },
    allList(){
      return this.list.length ? [...this.list,this.last] : []
    },
    msg(){
      let cs = this.list.filter(el => el.varietyLabelCode === 'chishi') || []
      let ls = this.list.filter(el => el.varietyLabelCode === 'lvshi') || []
      let csStocking = 0,lsStocking = 0,csWeight = 0,lsWeight = 0
      cs.forEach(el => {csStocking += Number(el[`${this.costField}Num`] || 0);csWeight += Number(el[`${this.costField}Weight`] || 0);})
      ls.forEach(el => {lsStocking += Number(el[`${this.costField}Num`] || 0);lsWeight += Number(el[`${this.costField}Weight`] || 0);})
      csStocking = csStocking.toFixed(0)
      lsStocking = lsStocking.toFixed(0)
      csWeight = csWeight.toFixed(this.len)
      lsWeight = lsWeight.toFixed(this.len)
      return <p class='margBm'>
          吃食鱼合计: <span class='colorBlue'>{csStocking}</span> 尾({csWeight}斤) 
          滤食鱼合计: <span class='colorBlue'>{lsStocking}</span>尾({lsWeight}斤)
        </p>
    }
  },
  mounted(){
    this.date = this.resDate ? moment(this.resDate) : null
  },
  methods: {
    ...mapMutations('empirical',['setState']),
    changeDate(){
      this.list.forEach(el => {
        this.changeVal(el)
      })
      this.$emit('changeDate',this.date ? moment(this.date).format('YYYY-MM-DD') : null)
    },
    changeVal(r){
      r[this.head.dateField] = this.date ? moment(this.date).format('YYYY-MM-DD') : null
    },
    openVariety(){
      this.setState({
        [this.varietyType]: true,
        // varietyVisible: true,
        varietySelect: this.list,
        paneType: this.listField,
        tabKey: this.tabKey,
        varietyDate: this.date ? moment(this.date).format('YYYY-MM-DD') : null,
        dateField: this.head.dateField,
      })
    },
  }

}
</script>

<style>

</style>